export default {"src":"/_next/static/media/poc-cloud-white.aa5dd3e2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};